export default {
  name: 'Render',
  functional: true,
  props: {
    params: Object,
    render: Function,
  },
  render: (h, ctx) => {
    const { params } = ctx.props;
    return ctx.props.render(h, params);
  },
};
